import React from 'react';
import {
  CardStreetAddress,
  CardCityInput,
  CardStateInput,
  CardZipInput,
  CardCountrySelect,
  CardEmailInput,
} from '../../components/payments';

const BillingFields = (props) => {
  const {
    addressLine1 = '',
    addressCity = '',
    addressState = '',
    addressZip = '',
    addressCountry = '',
    onChangeInput = () => {},
    showFields = {
      addressLine1: true,
      addressCity: true,
      addressState: true,
      addressZip: true,
      addressCountry: true,
    },
  } = props;

  return (
    <React.Fragment>
      <div className="row">
        {showFields.addressLine1 && (
          <div className="col-lg-12 col-md-12 col-xs-12">
            <CardStreetAddress
              onChange={onChangeInput('addressLine1')}
              required
              className="border-radius-4"
              name="addressLine1"
              placeholder="Street Address"
              style={styles.input}
              defaultValue={addressLine1}
            />
          </div>
        )}
      </div>
      <div className="row">
        {showFields.addressCity && (
          <div className="col-lg-5 col-md-5 col-xs-12">
            <CardCityInput
              onChange={onChangeInput('addressCity')}
              required
              className="border-radius-4"
              name="addressCity"
              placeholder="City"
              style={styles.input}
              defaultValue={addressCity}
            />
          </div>
        )}
        {showFields.addressState && (
          <div className="col-lg-4 col-md-4 col-xs-12">
            <CardStateInput
              onChange={onChangeInput('addressState')}
              required
              className="border-radius-4"
              name="addressState"
              placeholder="State"
              style={styles.input}
              defaultValue={addressState}
            />
          </div>
        )}
        {showFields.addressZip && (
          <div className="col-lg-3 col-md-3 col-xs-12">
            <CardZipInput
              onChange={onChangeInput('addressZip')}
              required
              className="border-radius-4"
              name="addressZip"
              placeholder="Zip Code"
              style={styles.input}
              defaultValue={addressZip}
            />
          </div>
        )}
        {showFields.addressCountry && (
          <div className="col-lg-12 col-md-12 col-xs-12">
            <CardCountrySelect
              onChange={onChangeInput('addressCountry')}
              required
              name="addressCountry"
              style={styles.input}
              defaultValue={addressCountry}
            />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

const styles = {
  input: {
    height: 46,
    fontSize: '1.5rem',
  },
};

export default BillingFields;
